// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"9b76c3c2","378":"1e06b85e","483":"c6592826"}[chunkId] + ".chunk.js";
};